import React, { CSSProperties } from 'react'
import styled, { keyframes } from 'styled-components'
import theme from 'styles/theme'
import { easings } from 'constants/easings'

interface SkeletonProps {
  delay?: number
  height?: string
  width?: string
  style?: CSSProperties
}

const defaultBaseColor = theme.skeleton.baseColor
const defaultHighlightColor = theme.skeleton.highlightColor

const skeletonKeyframes = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`

const SkeletonContainer = styled.div<SkeletonProps>`
  animation: ${skeletonKeyframes} 2s ${easings.easeOutExponential} infinite;
  animation-delay: ${props => `${props.delay}s`};
  background-color: ${defaultBaseColor};
  background-image: linear-gradient(
    135deg,
    ${defaultBaseColor},
    ${defaultHighlightColor},
    ${defaultBaseColor}
  );
  background-position: -200px 0;
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  display: inline-block;
  width: ${props => (props.width !== undefined ? props.width : '100%')};
  height: ${props => (props.height !== undefined ? props.height : '100%')};
  ${props => {
    if (props.width === undefined) return 'min-width: 20px;'
  }}
  ${props => {
    if (props.height === undefined) return 'min-height: 20px;'
  }}
`

const Skeleton: React.FC<SkeletonProps> = ({ ...props }) => (
  <SkeletonContainer role="skeleton" {...props} />
)

Skeleton.defaultProps = {
  delay: 0,
}

export default Skeleton
